import React from "react";

import type { RealEstateSourceAttribution } from "@features/real-estate/types";

type RealEstateSourceBadgeProps = {
  source: RealEstateSourceAttribution;
};

export function RealEstateSourceBadge({ source }: RealEstateSourceBadgeProps): React.ReactElement {
  const content = (
    <>
      <span>{source.name}</span>
      {source.retrievedAt ? <span className="re-source-meta">{source.retrievedAt}</span> : null}
    </>
  );

  if (!source.url) {
    return <span className="re-source-badge">{content}</span>;
  }

  return (
    <a className="re-source-badge" href={source.url} target="_blank" rel="noreferrer">
      {content}
    </a>
  );
}
